'use client';

import { Box } from '@wishket/design-system';

import { MOBILE_GRAPHICS, TABLET_GRAPHICS } from './Graphics';

import { useDeviceCheck } from '@/shared/hooks';

export const RollingGraphics = () => {
  const { isMobile } = useDeviceCheck();
  const GRAPHICS = isMobile ? MOBILE_GRAPHICS : TABLET_GRAPHICS;
  const repeatedGraphics = Array(4).fill(Object.values(GRAPHICS)).flat();

  return (
    <Box className="flex animate-rolling flex-col gap-y-3">
      {repeatedGraphics.map((Graphic, index) => (
        <Graphic key={index} />
      ))}
    </Box>
  );
};
